import { useEffect, useRef } from 'react';

// APRIRE I SETTINGS SU UNA PAGINA PRECISA, da qualunque punto dello Scene Editor (prototipo: l'ingranaggio della
// section Behavior dell'oggetto porta alle Experiences). Chi chiede non sa chi tiene la finestra — è lo Scene
// Editor, tre componenti più su —, quindi la richiesta viaggia come un evento, come il «mostra nell'elenco»
// del Composer (`composerReveal`).
const SETTINGS_EVENT = 'zakeke:scene-settings-request';

export type SceneSettingsPage = 'interface' | 'scene' | 'logics' | 'rendering' | 'behaviours' | 'ar' | 'vto';

export const requestSceneSettings = (page: SceneSettingsPage) => window.dispatchEvent(new CustomEvent<SceneSettingsPage>(SETTINGS_EVENT, { detail: page }));

/** Chi tiene la finestra ascolta qui: riceve la pagina da aprire. */
export const useSceneSettingsRequest = (onRequest: (page: SceneSettingsPage) => void) => {
    const handler = useRef(onRequest);
    handler.current = onRequest;
    useEffect(() => {
        const listener = (event: Event) => handler.current((event as CustomEvent<SceneSettingsPage>).detail);
        window.addEventListener(SETTINGS_EVENT, listener);
        return () => window.removeEventListener(SETTINGS_EVENT, listener);
    }, []);
};
